import api from '../utils/api';

export {
  createAccount,
  createWorkspace,
  fetchCurrentAccount,
  loginAccount,
} from './users';

export async function listAdminAccounts({ page = 1, perPage = 50, search = '' } = {}) {
  const params = { page, per_page: perPage };
  if (search) params.search = search;
  const { data } = await api.get('/admin/accounts', { params });
  return data;
}

export async function getAccountCatalogs(accountId) {
  const { data } = await api.get(`/admin/accounts/${accountId}/catalogs`);
  return data;
}

export async function updateAccountCatalogs(accountId, payload) {
  const { data } = await api.put(`/admin/accounts/${accountId}/catalogs`, payload);
  return data;
}
